import {required} from 'redux-form-validators';
import {LL} from 'shared/localization';

export const requiredInput = () => required({msg: LL('common.ui.requiredField')});
